<template>
  <div class="container-fluid bg-dark">
    <footer class="row py-3 justify-content-center">
      <div class="col-12 col-md-4 row align-self-center py-2">
        <span class="text-muted"><a class="text-muted" href="https://github.com/dobi8422"><i class="fab fa-github fs-3"></i></a> 2021.10, dobi8422</span>
      </div>
      <div class="col-12 col-md-4 d-flex justify-content-center text-muted">
        <ul class="row nav list-unstyled g-1">
          <li>09:00-17:00</li>
          <li>04-12345678</li>
          <li>400臺中市中區臺灣大道1段1號</li>
        </ul>
      </div>
      <div class="nav col-12 col-md-4 justify-content-center align-items-center py-2">
        <a href="#"><i class="fab fa-facebook ms-3 fs-2 text-muted"></i></a>
        <a href="#"><i class="fab fa-instagram ms-3 fs-2 text-muted"></i></a>
        <a href="#"><i class="fab fa-twitter ms-3 fs-2 text-muted"></i></a>
      </div>
    </footer>
  </div>
</template>

<style lang="scss" scoped>
li{ letter-spacing: 0.5px; }
</style>
